import { getKindergartenByPathname } from './GetKindergartenByPathname';

interface DataInput<T> {
  [key: string]: {
    nodes: T[];
  };
}

interface Node {
  parent: {
    name: string;
  };
}

export function getJsonByPathname<T extends Node, K>(data: K, pathname: string, jsonName: string): T | undefined {
  return ((data as unknown) as DataInput<T>)[jsonName].nodes.find(
    (node) => node.parent.name === getKindergartenByPathname(pathname),
  );
}
